import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import { ContactsContextProvider as ContactsProvider } from 'contexts/ContactsContext';

const Home = Loadable(lazy(() => import('pages/dashboard/home')));
const InvoicesTable = Loadable(lazy(() => import('pages/invoices/invoicesTable')));
const InvoiceProfile = Loadable(lazy(() => import('pages/invoices/invoiceProfile')));
const DemandeCarsTable = Loadable(lazy(() => import('pages/cars/demandeCarsTable')));
const RequestCarsTable = Loadable(lazy(() => import('pages/cars/requestCarsTable')));
const InventoryCarsTable = Loadable(lazy(() => import('pages/cars/inventoryCarsTable')));
const CarProfile = Loadable(lazy(() => import('pages/cars/carProfile')));
const TabCar = Loadable(lazy(() => import('sections/apps/profiles/car/TabCar')));

// ==============================|| APPS ROUTING ||============================== //

const ContactsRoutes = {
  path: '/',
  element: (
    <ContactsProvider>
      <Outlet />
    </ContactsProvider>
  ),
  children: [
    {
      path: '/home',
      element: <Home />
    },
    {
      path: '/demandes',
      element: <DemandeCarsTable />
    },
    {
      path: '/demandes/:id',
      element: <CarProfile />,
      children: [
        {
          path: '',
          element: <Navigate to="details" />
        },
        {
          path: 'details',
          element: <TabCar />
        }
      ]
    },
    {
      path: '/commandes',
      element: <RequestCarsTable />
    },
    {
      path: '/commandes/:id',
      element: <CarProfile />,
      children: [
        {
          path: '',
          element: <Navigate to="details" />
        },
        {
          path: 'details',
          element: <TabCar />
        }
      ]
    },
    {
      path: '/inventaire',
      element: <InventoryCarsTable />
    },
    {
      path: '/inventaire/:id',
      element: <CarProfile />,
      children: [
        {
          path: '',
          element: <Navigate to="details" />
        },
        {
          path: 'details',
          element: <TabCar />
        }
      ]
    },
    {
      path: '/invoices/:id',
      children: [
        {
          path: 'details',
          element: <InvoiceProfile />
        }
      ]
    },
    {
      path: '/invoices',
      element: <InvoicesTable />
    }
  ]
};

export default ContactsRoutes;
